import AICloudDeveloperPage from "./AICloudDeveloperPage";

export default function MLOpsEngineerPage() {
  return <AICloudDeveloperPage technology="mlops" />;
}
